export default __webpack_public_path__ + "static/media/detail_mobile_15_1.3119e119.jpg";